import ACTIONS from "./DashboardActionTypes";

//CARD
export const getDashboardCardRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_CARD_REQUEST,
  payload,
});

export const getDashboardCardResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_CARD_RESPONSE,
  payload,
});

//PIE
export const getDashboardPieEmployeeRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_EMPLOYEE_REQUEST,
  payload,
});

export const getDashboardPieEmployeeResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_EMPLOYEE_RESPONSE,
  payload,
});

export const getDashboardPieStatusRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_STATUS_REQUEST,
  payload,
});

export const getDashboardPieStatusResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_STATUS_RESPONSE,
  payload,
});

export const getDashboardPieGroupByPurposeRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_REQUEST,
  payload,
});

export const getDashboardPieGroupByPurposeResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_GROUPBY_PURPOSE_OF_RESPONSE,
  payload,
});

export const getDashboardPieCreatedByRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_CREATED_BY_REQUEST,
  payload,
});

export const getDashboardPieCreatedByResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_PIE_CREATED_BY_RESPONSE,
  payload,
});

//

export const getDashboardLineChartMonthlyRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_LINE_CHART_MONTHLY_REQUEST,
  payload,
});

export const getDashboardLineChartMonthlyResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_LINE_CHART_MONTHLY_RESPONSE,
  payload,
});

export const getDashboardLineChartYearlyRequest = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_LINE_CHART_YEARLY_REQUEST,
  payload,
});

export const getDashboardLineChartYearlyResponse = (payload) => ({
  type: ACTIONS.GET_DASHBOARD_LINE_CHART_YEARLY_RESPONSE,
  payload,
});
